export enum CandidatesRoutingEnum {
  List = 'list',
}
